/**
 * 教培管理 PC 后管 — 侧栏菜单与路由元信息
 * 页面组件目录：src/pages/schools/admin/
 * menuKey 与 sys_user.h5_admin_menus 对齐（精确到二级页）
 */

import { H5_ADMIN_MENU_KEYS, hasH5AdminMenu } from '@/pages/admin/config/admin-menus'

export const SCHOOLS_ADMIN_MENU_ROOT = '/admin/schools'

export const schoolsAdminMenus = [
  {
    key: H5_ADMIN_MENU_KEYS.SCHOOLS_PLATFORM_ORGS,
    index: '/admin/schools/platform-orgs',
    title: '机构管理',
    icon: 'el-icon-office-building',
    platformAdminOnly: true
  },
  {
    key: H5_ADMIN_MENU_KEYS.SCHOOLS_DASHBOARD,
    index: '/admin/schools/dashboard',
    title: '工作台',
    icon: 'el-icon-s-data'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SCHOOLS_SUBJECT,
    index: '/admin/schools/subject',
    title: '科目管理',
    icon: 'el-icon-menu'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SCHOOLS_COURSE,
    index: '/admin/schools/course',
    title: '课程产品',
    icon: 'el-icon-reading'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SCHOOLS_CLASS,
    index: '/admin/schools/class',
    title: '班级管理',
    icon: 'el-icon-s-grid'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SCHOOLS_SCHEDULE,
    index: '/admin/schools/schedule',
    title: '排课中心',
    icon: 'el-icon-date'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SCHOOLS_STUDENT,
    index: '/admin/schools/student',
    title: '学员档案',
    icon: 'el-icon-user'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SCHOOLS_ENROLL,
    index: '/admin/schools/enroll',
    title: '报名订单',
    icon: 'el-icon-s-order'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SCHOOLS_ATTENDANCE,
    index: '/admin/schools/attendance',
    title: '考勤课消',
    icon: 'el-icon-circle-check'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SCHOOLS_LEAVE,
    index: '/admin/schools/leave',
    title: '请假管理',
    icon: 'el-icon-document-remove'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SCHOOLS_TEACHER,
    index: '/admin/schools/teacher',
    title: '教师管理',
    icon: 'el-icon-s-custom'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SCHOOLS_ROOM,
    index: '/admin/schools/room',
    title: '教室管理',
    icon: 'el-icon-office-building'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SCHOOLS_NOTICE,
    index: '/admin/schools/notice',
    title: '通知公告',
    icon: 'el-icon-bell'
  },
  {
    key: H5_ADMIN_MENU_KEYS.SCHOOLS_SETTING,
    index: '/admin/schools/setting',
    title: '机构设置',
    icon: 'el-icon-setting'
  }
]

/** 供 routers.js 注册的 child routes */
export function buildSchoolsAdminRoutes() {
  const meta = { requiresH5Admin: true, requiresSchoolsOrg: true }
  const platformMeta = { requiresH5Admin: true, platformAdminOnly: true }
  const load = name => () => import(`../admin/${name}.vue`)

  return [
    { path: 'schools', redirect: 'schools/dashboard' },
    {
      path: 'schools/platform-orgs',
      name: 'SchoolsPlatformOrgs',
      component: load('platform-orgs'),
      meta: { ...platformMeta, title: '机构管理', h5AdminMenu: H5_ADMIN_MENU_KEYS.SCHOOLS_PLATFORM_ORGS }
    },
    {
      path: 'schools/dashboard',
      name: 'SchoolsDashboard',
      component: load('dashboard'),
      meta: { ...meta, title: '工作台', h5AdminMenu: H5_ADMIN_MENU_KEYS.SCHOOLS_DASHBOARD }
    },
    {
      path: 'schools/subject',
      name: 'SchoolsSubject',
      component: load('subject'),
      meta: { ...meta, title: '科目管理', h5AdminMenu: H5_ADMIN_MENU_KEYS.SCHOOLS_SUBJECT }
    },
    {
      path: 'schools/course',
      name: 'SchoolsCourse',
      component: load('course'),
      meta: { ...meta, title: '课程产品', h5AdminMenu: H5_ADMIN_MENU_KEYS.SCHOOLS_COURSE }
    },
    {
      path: 'schools/class',
      name: 'SchoolsClass',
      component: load('class'),
      meta: { ...meta, title: '班级管理', h5AdminMenu: H5_ADMIN_MENU_KEYS.SCHOOLS_CLASS }
    },
    {
      path: 'schools/class/:id',
      name: 'SchoolsClassDetail',
      component: load('class-detail'),
      meta: { ...meta, title: '班级详情', h5AdminMenu: H5_ADMIN_MENU_KEYS.SCHOOLS_CLASS }
    },
    {
      path: 'schools/schedule',
      name: 'SchoolsSchedule',
      component: load('schedule'),
      meta: { ...meta, title: '排课中心', h5AdminMenu: H5_ADMIN_MENU_KEYS.SCHOOLS_SCHEDULE }
    },
    {
      path: 'schools/student',
      name: 'SchoolsStudent',
      component: load('student'),
      meta: { ...meta, title: '学员档案', h5AdminMenu: H5_ADMIN_MENU_KEYS.SCHOOLS_STUDENT }
    },
    {
      path: 'schools/student/:id',
      name: 'SchoolsStudentDetail',
      component: load('student-detail'),
      meta: { ...meta, title: '学员详情', h5AdminMenu: H5_ADMIN_MENU_KEYS.SCHOOLS_STUDENT }
    },
    {
      path: 'schools/enroll',
      name: 'SchoolsEnroll',
      component: load('enroll'),
      meta: { ...meta, title: '报名订单', h5AdminMenu: H5_ADMIN_MENU_KEYS.SCHOOLS_ENROLL }
    },
    {
      path: 'schools/attendance',
      name: 'SchoolsAttendance',
      component: load('attendance'),
      meta: { ...meta, title: '考勤课消', h5AdminMenu: H5_ADMIN_MENU_KEYS.SCHOOLS_ATTENDANCE }
    },
    {
      path: 'schools/leave',
      name: 'SchoolsLeave',
      component: load('leave'),
      meta: { ...meta, title: '请假管理', h5AdminMenu: H5_ADMIN_MENU_KEYS.SCHOOLS_LEAVE }
    },
    {
      path: 'schools/teacher',
      name: 'SchoolsTeacher',
      component: load('teacher'),
      meta: { ...meta, title: '教师管理', h5AdminMenu: H5_ADMIN_MENU_KEYS.SCHOOLS_TEACHER }
    },
    {
      path: 'schools/room',
      name: 'SchoolsRoom',
      component: load('room'),
      meta: { ...meta, title: '教室管理', h5AdminMenu: H5_ADMIN_MENU_KEYS.SCHOOLS_ROOM }
    },
    {
      path: 'schools/notice',
      name: 'SchoolsNotice',
      component: load('notice'),
      meta: { ...meta, title: '通知公告', h5AdminMenu: H5_ADMIN_MENU_KEYS.SCHOOLS_NOTICE }
    },
    {
      path: 'schools/setting',
      name: 'SchoolsSetting',
      component: load('setting'),
      meta: { ...meta, title: '机构设置', h5AdminMenu: H5_ADMIN_MENU_KEYS.SCHOOLS_SETTING }
    }
  ]
}

/** 侧栏高亮：详情页回落到列表菜单 */
export function resolveSchoolsAdminActiveMenu(path) {
  if (!path || path.indexOf('/admin/schools') !== 0) return path
  if (/^\/admin\/schools\/class\//.test(path)) return '/admin/schools/class'
  if (/^\/admin\/schools\/student\//.test(path)) return '/admin/schools/student'
  return path
}

/**
 * 教培侧栏：平台超管专属 + H5 菜单权限（精确到二级）
 */
export function filterSchoolsAdminMenus(userInfo) {
  const platformAdmin = userInfo && userInfo.schoolsPlatformAdmin
  return schoolsAdminMenus.filter(item => {
    if (item.platformAdminOnly && !platformAdmin) return false
    return hasH5AdminMenu(userInfo, item.key)
  })
}
